import { Injectable } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';

@Injectable({ providedIn: 'root' })
export class TourUiBridgeService {
  private profileTrigger: MatMenuTrigger | null = null;

  public setProfileTrigger(trigger: MatMenuTrigger | null): void {
    this.profileTrigger = trigger;
  }

  public openProfileMenu(): void {
    this.profileTrigger?.openMenu();
  }

  public closeProfileMenu(): void {
    this.profileTrigger?.closeMenu();
  }
}
